export function calculateXYAngle(x: number, y: number): number {
  const angle = Math.atan2(y, x);
  return angle < 0 ? angle + 2 * Math.PI : angle;
}

export function radToTurn(rad: number): number {
  return rad / (2 * Math.PI);
}

export function turnToRad(turn: number): number {
  return turn * 2 * Math.PI;
}
